import type { ReactNode } from "react";
import { Icon } from "./Icon";
import { FieldLabel } from "./ui";

type Props = {
  title: string;
  meta?: string;
  collapsed: boolean;
  onToggle: () => void;
  children: ReactNode;
  className?: string;
};

export function CollapsibleSection({
  title,
  meta,
  collapsed,
  onToggle,
  children,
  className = "",
}: Props) {
  return (
    <section
      className={`border-b border-outline-variant bg-surface-container-low ${collapsed ? "shrink-0" : ""} ${className}`}
    >
      <button
        type="button"
        onClick={onToggle}
        className="w-full px-6 py-2.5 flex items-center justify-between gap-3 text-left hover:bg-surface-container transition-colors"
        aria-expanded={!collapsed}
      >
        <div className="min-w-0">
          <FieldLabel>{title}</FieldLabel>
          {meta && !collapsed ? (
            <p className="text-body-sm font-data-mono text-on-surface-variant truncate mt-0.5">
              {meta}
            </p>
          ) : null}
          {meta && collapsed ? (
            <p className="text-body-sm font-data-mono text-outline truncate mt-0.5">{meta}</p>
          ) : null}
        </div>
        <Icon
          name={collapsed ? "expand_more" : "expand_less"}
          className="text-on-surface-variant shrink-0"
        />
      </button>
      {!collapsed ? children : null}
    </section>
  );
}
